import { constants } from '@/constants';

export enum HelpOptionKey {
  PlanATrip = 'plan-a-trip',
  PassportVisa = 'passport-visa',
  TravelInsurance = 'travel-insurance',
  InternationalDrivingPermits = 'international-driving-permits',
  Triptiks = 'triptiks',
  MexicoAutoInsurance = 'mexico-auto-insurance',
  ForeignCurrencyExchange = 'foreign-currency-exchange',
  NotaryServices = 'notary-services',
}

// `flow` advances into the current flow; HelpSelection resolves the URL
// from its `flow` prop. `external` jumps to a self-service site.
export type HelpOptionAction =
  | { readonly type: 'flow' }
  | { readonly type: 'external'; readonly url: string };

export interface HelpOption {
  readonly key: HelpOptionKey;
  readonly title: string;
  readonly description: string;
  readonly imageSrc: string;
  readonly iconBg: string;
  readonly imageAlignTopRight?: boolean;
  readonly action: HelpOptionAction;
  readonly testId: string;
}

const ICONS_BASE = '/travel/agent/scheduler/helpSelectionIcons';

const SELF_SERVICE_DESCRIPTION =
  'No appointments required. Click here for details on self-services.';

const TRAVEL_INSURANCE_DESCRIPTION =
  'No appointments required. Click here for details on self-service.';

export const helpOptions: readonly HelpOption[] = [
  {
    key: HelpOptionKey.PlanATrip,
    title: 'Plan a trip',
    description: 'Work with a travel specialist to plan your next destination.',
    imageSrc: `${ICONS_BASE}/planATrip.png`,
    iconBg: '#EBF3FF',
    imageAlignTopRight: true,
    action: { type: 'flow' },
    testId: `help-option-${HelpOptionKey.PlanATrip}`,
  },
  {
    key: HelpOptionKey.InternationalDrivingPermits,
    title: 'International driving permits',
    description: SELF_SERVICE_DESCRIPTION,
    imageSrc: `${ICONS_BASE}/internationalDrivingPermits.png`,
    iconBg: '#F5F5F5',
    action: { type: 'external', url: constants.DRIVING_PERMITS_URL },
    testId: `help-option-${HelpOptionKey.InternationalDrivingPermits}`,
  },
  {
    key: HelpOptionKey.PassportVisa,
    title: 'Passport & Visa',
    description: SELF_SERVICE_DESCRIPTION,
    imageSrc: `${ICONS_BASE}/passportVisa.png`,
    iconBg: '#E8F5EE',
    action: { type: 'external', url: constants.PASSPORT_PHOTOS_URL },
    testId: `help-option-${HelpOptionKey.PassportVisa}`,
  },
  {
    key: HelpOptionKey.TravelInsurance,
    title: 'Travel insurance',
    description: TRAVEL_INSURANCE_DESCRIPTION,
    imageSrc: `${ICONS_BASE}/travelInsurance.png`,
    iconBg: '#ECFAFB',
    action: { type: 'external', url: constants.TRAVEL_INSURANCE_URL },
    testId: `help-option-${HelpOptionKey.TravelInsurance}`,
  },
  {
    key: HelpOptionKey.Triptiks,
    title: 'TripTiks',
    description: SELF_SERVICE_DESCRIPTION,
    imageSrc: `${ICONS_BASE}/triptiks.png`,
    iconBg: '#FFF8E6',
    action: { type: 'external', url: constants.DRIVING_DIRECTIONS_URL },
    testId: `help-option-${HelpOptionKey.Triptiks}`,
  },
  {
    key: HelpOptionKey.ForeignCurrencyExchange,
    title: 'Foreign currency exchange',
    description: SELF_SERVICE_DESCRIPTION,
    imageSrc: `${ICONS_BASE}/foreignCurrencyExchange.png`,
    iconBg: '#F4EDFF',
    action: { type: 'external', url: constants.FOREIGN_CURRENCY_URL },
    testId: `help-option-${HelpOptionKey.ForeignCurrencyExchange}`,
  },
  {
    key: HelpOptionKey.NotaryServices,
    title: 'Notary services',
    description: SELF_SERVICE_DESCRIPTION,
    imageSrc: `${ICONS_BASE}/notaryServices.png`,
    iconBg: '#FFFBEB',
    action: { type: 'external', url: constants.NOTARY_SERVICES_URL },
    testId: `help-option-${HelpOptionKey.NotaryServices}`,
  },
  {
    key: HelpOptionKey.MexicoAutoInsurance,
    title: 'Mexico auto insurance',
    description: SELF_SERVICE_DESCRIPTION,
    imageSrc: `${ICONS_BASE}/mexicoAutoInsurance.png`,
    iconBg: '#E6F6F5',
    action: { type: 'external', url: constants.MEXICO_AUTO_INSURANCE_URL },
    testId: `help-option-${HelpOptionKey.MexicoAutoInsurance}`,
  },
];

export const DEFAULT_SELECTED_OPTION_KEY = HelpOptionKey.PlanATrip;
